export default function storeState(storageKey: string, payload: any) {
  const jsonValue = JSON.stringify(payload);
  localStorage.setItem(storageKey, jsonValue);
}

export function emptyState(storageKey: string) {
  localStorage.removeItem(storageKey);
}
